import { useLocation } from "react-router-dom";
import { BiCheck } from "react-icons/bi";
import Button from "@components/button/Button";
import { FEModules } from "@utils/moduleList";

interface TopbarStepIconProps {
	stepId: number;
	isActive: boolean;
	index: number;
	statusName?: string;
}

const TopbarStepIcon = ({
	stepId,
	isActive,
	index,
	statusName,
}: TopbarStepIconProps) => {
	const location = useLocation();
	const isInBuilder = location.pathname.includes("/builder");

	const isNotFirst = stepId !== 0;
	const buttonClasses = `${isNotFirst && "ms-2"} ${isActive && "step-number-active"
		} ${statusName === "READY" && isInBuilder
			? "step-number-done"
			: isActive
				? "step-number-touched" :
				""
		} step-number ff-bold`;

	return (
		<div>
			{stepId === FEModules.ActivityComplete ? (
				<Button className={buttonClasses}>
					<BiCheck size={20} />
				</Button>
			) : (
				<Button className={buttonClasses}>{index + 1}</Button>
			)}
		</div>
	);
};

export default TopbarStepIcon;
